import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastService } from '../toast/toast.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly validUsername = 'Cosbotadmin';
  private readonly validPassword = 'A0w0CoSB$!t7';
  private isAuthenticated = false;

  constructor(private router: Router, private toastService: ToastService) { }

  login(username: string, password: string): boolean {
    if (!username || !password) {
      this.toastService.showToast('Please enter both username and password', 'error', 400);
      return false;
    }

    if (username === this.validUsername && password === this.validPassword) {
      this.isAuthenticated = true;
      localStorage.setItem('isLoggedIn', 'true');
      this.router.navigate(['/']);
      this.toastService.showToast('Login successful!', 'success', 200);
      return true;
    } else {
      this.toastService.showToast('Invalid credentials', 'error', 401);
      return false;
    }
  }

  logout(): void {
    this.isAuthenticated = false;
    localStorage.removeItem('isLoggedIn');
    this.router.navigate(['/login']);
  }

  isLoggedIn(): boolean {
    return this.isAuthenticated || localStorage.getItem('isLoggedIn') === 'true';
  }
}
